<template>
    <b-container class="partner-type-container">
        <b-row>
            <b-col cols="6" md="3" class="p-sm-0 p-md-2" >
                <Link href="/districts">
                    <b-card
                        :img-src="`${routes.cdn_url}/images/redesign/home/user-types/districts-bear.svg`"
                        img-alt="Image"
                        img-top
                        tag="article"
                        class="mb-2 p-0"
                        role="button"
                    >
                        <p class="partner-type">Districts</p>
                    </b-card>
                </Link>
            </b-col>
            <b-col cols="6" md="3" class="p-sm-0 p-md-2">
                <Link href="/administrators">
                    <b-card
                        :img-src="`${routes.cdn_url}/images/redesign/home/user-types/administrators-llama.svg`"
                        img-alt="Image"
                        img-top
                        tag="article"
                        class="mb-2 p-0"
                        role="button"
                    >
                        <p class="partner-type">Administrators</p>
                    </b-card>
                </Link>
            </b-col>
            <b-col cols="6" md="3" class="p-sm-0 p-md-2" >
                <Link href="/teachers">
                    <b-card
                        :img-src="`${routes.cdn_url}/images/redesign/home/user-types/teachers-cat.svg`"
                        img-alt="Image"
                        img-top
                        tag="article"
                        class="mb-2 p-0"
                        role="button"
                    >
                        <p class="partner-type">Teachers</p>
                    </b-card>
                </Link>
            </b-col>
            <b-col cols="6" md="3" class="p-sm-0 p-md-2">
                <Link href="/students">
                    <b-card
                        :img-src="`${routes.cdn_url}/images/redesign/home/user-types/students-bunny.svg`"
                        img-alt="Image"
                        img-top
                        tag="article"
                        class="mb-2 p-0"
                        role="button"
                    >
                        <p class="partner-type">Students</p>
                    </b-card>
                </Link>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>    
    export default {
    }
</script>

<style lang="scss" scoped>
    .partner-type-container {
        width: 100%;
        margin: 5vh auto;
        margin-top: 18rem;

        a {
            text-decoration: none;
        }

        .row {
            margin: 0;
            justify-content: space-between;
        }
                
        .card {
            transition: transform .2s linear;
                -webkit-transition: transform .2s linear;
                -moz-transition: transform .2s linear;
                -ms-transition: transform .2s linear;

            &:hover {
                transform: scale(1.1);
                -moz-transform: scale(1.1);
                -webkit-transform: scale(1.1);
                -o-transform: scale(1.1);
                -ms-transform: scale(1.1);
                -webkit-transform: scale(1.1);
            }
            .partner-type {
                color: #fff;
                width: 100%;
                background: #005ec0;
                box-shadow: 0px 18px 40px -12px rgba(0,0,0,.1);
                font-size: 1.3rem;
                padding: 1rem;
                margin: 0 auto;
                text-align: center;

                transition: background .2s linear;
                    -webkit-transition: background .2s linear;
                    -moz-transition: background .2s linear;
                    -ms-transition: background .2s linear;
            }
            &:hover .partner-type {
                background: #3987d8;
                box-shadow: 0px 18px 40px -12px rgba(0,0,0,.15);
            }
            > img {
                width: 100%;
            }
            .card-body {
                padding: 0;
            }
        }
    }
    @media (max-width: 992px) {
        .partner-type-container {
            margin-top: 10rem;
            .partner-type {
                font-size: .9rem !important;
            }
        }
    }
    @media (max-width: 770px) {
        .card {
            transform: scale(.8);
                -moz-transform: scale(.8);
                -webkit-transform: scale(.8);
                -o-transform: scale(.8);
                -ms-transform: scale(.8);
                -webkit-transform: scale(.8);
                &:hover {
                    transform: scale(.9);
                        -moz-transform: scale(.9);
                        -webkit-transform: scale(.9);
                        -o-transform: scale(.9);
                        -ms-transform: scale(.9);
                        -webkit-transform: scale(.9);
                }
        }
        .partner-type-container {
            .partner-type {
                font-size: 1.3rem !important;
            }
        }
    }
    @media (max-width: 576px) {
        .card {
            transform: scale(.9);
                -moz-transform: scale(.9);
                -webkit-transform: scale(.9);
                -o-transform: scale(.9);
                -ms-transform: scale(.9);
                -webkit-transform: scale(.9);
                &:hover {
                    transform: scale(1);
                        -moz-transform: scale(1);
                        -webkit-transform: scale(1);
                        -o-transform: scale(1);
                        -ms-transform: scale(1);
                        -webkit-transform: scale(1);
                }
        }
    }

</style>
